import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { AlgGtmService } from '../../../services/alg-gtm.service';

@Component({
  selector: 'alg-faq-card',
  templateUrl: './alg-faq-card.component.html',
  styleUrls: ['./alg-faq-card.component.scss'],
})
export class AlgFaqCardComponent implements OnInit {
  public questionItems: any = null;

  constructor(private api: ApiService, private gtm: AlgGtmService) {}

  ngOnInit() {
    return this.api
      .getFaqList()
      .toPromise()
      .then((response: any) => {
        this.questionItems = response.data.filter((i) => {
          i.isOpen = false;
          return i.active;
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  public openItem(id: string) {
    this.questionItems.map((i) => {
      i.isOpen = id === i._id ? !i.isOpen : false;
      if (i.isOpen) {
        this.gtm.submitOnbEvent('Visualizzazione faq', i.question);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/molecules/alg-faq-card/alg-faq-card.component.ts